import Dict, { basicTypes, Schema } from '@togglecorp/ravl';
import { isProduction } from '#config/env';

import userSchema from './users';
import dailyLogSchema from './dailyLogs';
import travelSchema from './travel';
import commonSchema from './common';
import leaveSchema from './leave';
import timesheetSchema from './timesheet';
import superviseSchema from './supervise';

const userDefinedSchemas: Schema[] = [
    {
        doc: {
            name: 'dbentity',
            description: 'Defines all the attributes common to db entities',
        },
        fields: {
            id: { type: 'uint', required: true },
            // FIXME: is at inconsistent state. update required: true when fixed in server
            createdAt: { type: 'string' }, // date
            modifiedAt: { type: 'string' }, // date
            createdBy: { type: 'uint' },
            modifiedBy: { type: 'uint' },
        },
    },
];

const warning = !isProduction;
const dict = new Dict({ warning });

[
    ...basicTypes,
    ...userDefinedSchemas,
    ...userSchema,
    ...dailyLogSchema,
    ...travelSchema,
    ...commonSchema,
    ...leaveSchema,
    ...timesheetSchema,
    ...superviseSchema,
].forEach(schema => dict.put(schema.doc.name, schema));

export default dict;
